/**
 * Get the value of a CSS variable.
 * @param {string} variableName - The name of the CSS variable (e.g., "--primary-color").
 * @returns {string} The value of the CSS variable.
 */
export const getCssVariable = (variableName) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
};

/**
 * Validates whether all required fields are filled/selected.
 * @param {Object} formData - The current form state, keyed by element IDs.
 * @param {Array} requiredFields - Array of IDs for required fields.
 * @returns {boolean} - True if all required fields are valid, false otherwise.
 */
export const areRequiredFieldsValid = (formData, requiredFields) => {
  return requiredFields.every((id) => {
    const field = formData[id];
    if (!field) {
      return false;
    }

    const value = field.value;

    // Handle input fields (stored as array of options with values)
    if (Array.isArray(value) && value.length > 0 && value[0].hasOwnProperty('required')) {
      // This is an input field question - check if all required inputs have values
      const requiredInputs = value.filter(option => option.required);
      return requiredInputs.every(option => 
        option.value && option.value.toString().trim() !== ''
      );
    }

    // Handle regular arrays (multiple choice)
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    // Handle single values
    return value !== null && value !== '';
  });
};
